import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getPlayerClaimHistory } from '@/api/activity';
import ChestUserDetails from '@/themes/themeOne/activeChest/components/chestUserDetails.vue';
import ChestUserDetailsTwo from '@/themes/themeTwo/activeChest/components/chestUserDetails.vue';
import { ChestUserData, PAGE_SIZE, PlayListItem } from '../supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'chestUserDetails',
  setup(__props) {

const themeStore = useThemeStore()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()

const activeTabStatus = ref<any>('')
const total = ref(0)
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const playersList = ref<PlayListItem[]>([])


const dataSet = computed<ChestUserData>(() => ({
  playersList: playersList.value,
  total: total.value,
  pageSize: pageSize.value,
  pageNum: pageNum.value
}))

const onClickTab = (active: any) => {
    total.value = 0
    pageNum.value = 1
    playersList.value = []
    if (active.name == 0) {
        activeTabStatus.value = '' // all
        getHistory()
    } else if (active.name == 1) {
        activeTabStatus.value = 1 // active/completed
        getHistory()
    } else if (active.name == 2) {
        activeTabStatus.value = 2 // inactive/fail
        getHistory()
    } else if (active.name == 3) {
        activeTabStatus.value = 0 // pending
        getHistory()
    }

}
const getNextPageMsgList = () => {
    if (total.value > pageSize.value * pageNum.value) {
        pageNum.value = pageNum.value + 1
        getHistory()
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getHistory = () => {
    loadingRef.value.open()
    let data = {
        status: activeTabStatus.value,
        pageNum: pageNum.value,
        pageSize: pageSize.value
    }
    getPlayerClaimHistory(data).then(res => {
        loadingRef.value.close()
        playersList.value = [...playersList.value, ...res.data?.records]
        total.value = res.data?.total || 0
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
onMounted(() => {
    getHistory()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ChestUserDetails, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onGetNextPageMsgList: getNextPageMsgList
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ChestUserDetailsTwo, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onGetNextPageMsgList: getNextPageMsgList
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})